export const STATES = {
  VIGUEUR: "VIGUEUR",
  ABROGE: "ABROGE",
};
